import _ from "lodash";
import { getActivePinia, defineStore } from "pinia";

const ignoreResetModules = ["portalCustomization", "loginRedirect", "featureFlag", "outageNotification", "custodianSettings", "biometricAuth"];

type Predicate = (testValue: any) => boolean;

export function filteredReset (predicate: Predicate) {
  const activepinia = getActivePinia();
  if (activepinia) {
    Object.entries(activepinia.state.value).forEach(([ storeName, state ]) => {
      if (predicate(storeName)) {
        const storeDefinition = defineStore(storeName, state);
        const store = storeDefinition(activepinia);
        store.$reset();
      }
    });
  }
}

export function reset () {
  const testNotIngoredModule: Predicate = keyName => !ignoreResetModules.find(e => e === keyName);
  filteredReset(testNotIngoredModule);
}

export function resetAllPiniaStores () {
  const activepinia = getActivePinia();
  if (activepinia) {
    Object.entries(activepinia.state.value).forEach(([storeName, state]) => {
      if (!ignoreResetModules.includes(storeName)) {
        const storeDefinition = defineStore(storeName, state);
        const store = storeDefinition(activepinia);
        store.$reset();
      }
    });
  }
}